/*********************** Custom JS for Boost AI Search & Discovery  ************************/
if (window.boostSDAppConfig) { window.boostSDAppConfig.integration = Object.assign({ wishlists: 'plus' }, window.boostSDAppConfig.integration || {}); }


const customize = {
  moveHeaderDescription: (componentRegistry) => {
    componentRegistry.useComponentPlugin("HeaderDescription", {
      name: "Move Collection Description Below Product List",
      apply: () => {
         let hasUpdated = false; // Prevent rendering twice
         return {
            afterRender(element) {
               try {
                  const descriptionElement = element.getRootElm();
                  if (descriptionElement && !hasUpdated) {
                     hasUpdated = true;
                     const productListContainerElement = document.querySelector(".boost-sd__filter-block .boost-sd-container"); // Select product list
                     if (productListContainerElement) {
                        productListContainerElement.appendChild(descriptionElement); // Move to below product list
                     }
                  }
               } catch (err) {
                  console.warn(err);
               }
            }
         }
      }
   })
  }, 
  removeOOSProductSwatches: (componentRegistry) => {
      componentRegistry.useComponentPlugin('ProductSwatch', {
         name: 'Customize swatches',
         enabled: true,
         apply: () => ({
            props: (props) => {
               props.maxItem = 100; // Show all swatches by increasing number of swatches displayed to 100 (optional)
               return props;
            },
            afterRender(element) {
               const swatchOptions = element?.getParams()?.props?.options;
               const productData =
                  componentRegistry.getNearestParentElm(element, 'ProductItemWidget')?.getParams()?.props?.product ||
                  componentRegistry.getNearestParentElm(element, 'QuickView')?.getParams()?.props?.productData;
               if (swatchOptions?.length && productData) {
                  const productVariants = productData.variants || [];
                  swatchOptions.forEach((option) => {
                     const optionValue = option.value;
                     option.available = checkOptionStatus(productVariants, optionValue);
                     if (!option.available) {
                        const swatchOption = document.querySelector(`label[for*="${option.id}"]`);
                        if (swatchOption && swatchOption.closest('.boost-sd__product-swatch-option')) {
                           swatchOption.closest('.boost-sd__product-swatch-option').classList.add('sold-out');
                        }
                     }
                  });
               }
            },
         }),
      });
   },
    updateProductItemGrid: (componentRegistry) => {
      componentRegistry.useComponentPlugin('ProductItem', {
         name: 'Add extra information',
         enabled: true,
         apply: () => ({
            afterRender(element) {
               try {
                  // Start customization--------------------------------------------
                  let productData = element.getParams().props.product;
                  let productId = productData.id;
                  if (productData?.split_product) {
                     productId = productData.variant_id;
                  }
                  let productItem = document.querySelector('[data-product-id="' + productId + '"]');
                  if (productItem) {
                      let label = productData.metafields.find(e => e.namespace == 'theme' && e.key == 'label');
                      if (typeof label != 'undefined') {
                        console.log(label);
                        const labelHtml = `<div class="boost-sd__product-label boost-sd__product-label--text boost-sd__product-label--rectangle boost-sd__product-label--custom-meta">
                                              <span class="boost-sd__product-label-text">
                                                <span>${label.value}</span>
                                              </span>
                                            </div>`;
                        if (!productItem.querySelector('.boost-sd__product-label--custom-meta')) {
                           productItem.querySelector('.boost-sd__product-image-column.boost-sd__product-image-column--in-top.boost-sd__product-image-column--right').insertAdjacentHTML('beforeend', labelHtml);
                        }
                      }
                  }
                  // End-------------------------------------------------------------
               } catch (e) {
                  console.warn(e);
               }
            }
         }),
      });
   }
}

window.__BoostCustomization__ = (window.__BoostCustomization__ ?? []).concat([
  customize.moveHeaderDescription,
  customize.removeOOSProductSwatches,
  customize.updateProductItemGrid
]);

function checkOptionStatus(variants, optionValue) {
   for (let i = 0; i < variants.length; i++) {
      const variant = variants[i];
      const variantOptions = variant.title?.split(' / ') || [];
      if (variantOptions.some((option) => option.toLowerCase() === optionValue.toLowerCase() && variant.available)) {
         return true;
      }
   }
   return false;
}